/** @format */
import { FilterTextField, FilterSelective, FilterDateRange } from 'components';
import { TableItemActionsNew } from 'components';
const status = [
  {
    label: 'همه',
    value: '',
  },
  {
    label: 'موفق',
    value: 'true',
  },
  {
    label: 'ناموفق',
    value: 'false',
  },
];

const columns = (handleOpenDialog, navigate , currencyText) => [
  {
    title: 'شناسه سرویس',
    field: 'serviceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'نام سرویس',
    field: 'serviceName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'تاریخ و زمان فراخوانی',
    field: 'dateTimeCalling',
    align: 'center',
    filterComponent: (props) => <FilterDateRange size="small" {...props} />,
  },
  {
    title: 'نتیجه فراخوانی',
    field: 'callResult',
    align: 'center',
    filterComponent: (props) => <FilterSelective options={status} size="small" {...props} />,
  },
  {
    title: 'سرویس دهنده',
    field: 'serviceProdvider',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: `قیمت (${currencyText})`,
    field: 'price',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'شماره فاکتور',
    field: 'factorId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'عملیات',
    field: 'actions',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'مجموعه سرویس',
            isShow: true,
            onClick: () => {
              handleOpenDialog(rowData.serviceId)
            },
          },
          {
            title: 'جزئیات فاکتور',
            isShow: true,
            onClick: () => {
              navigate(`/Invoice/${rowData.factorId}/invoice-details`)
            },
            disabled: !rowData.factorId,
          },
        ]}
      />
    ),
  },
];

const columnsId = {
  serviceId: '1294',
  serviceName: '1290',
  dateTimeCalling: ['1439', '1440'],
  callResult: '1438',
  serviceProdvider: '1291',
  price: ['1292', '1293'],
  serviceSet: null,
  factorId: '1295',
};

export { columns, columnsId };
